import { useState, useEffect } from "react";
import { Tag } from "lucide-react";
import CategorieForm from "./CategorieForm";
import { Categorie, BaseCategorie } from "../../../../types/features/Post";
import { categorieService } from "../../../../services/categorieService";
import { alertSuccess, alertError } from "../../../../helpers/alertError";
import BaseModal from "../../../ui/Modal";
import useToken from "../../../../hooks/features/auth/useToken";

interface CategorieModalProps {
  isOpen: boolean;
  onClose: () => void;
  mode: "create" | "edit";
  categorie?: Categorie;
  onSuccess: () => void;
}

export default function CategorieModal({ isOpen, onClose, mode, categorie, onSuccess }: CategorieModalProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [initialData, setInitialData] = useState<Partial<BaseCategorie> | undefined>(undefined);
  const {token} = useToken()


  useEffect(() => {
    if (mode === "edit" && categorie) {
      setInitialData({
        name: categorie.name,
        name_en: categorie.name_en,
        description: categorie.description,
        description_en: categorie.description_en,
      });
    } else {
      setInitialData(undefined);
    }
  }, [mode, categorie, isOpen]);

  const handleSubmit = async (data: BaseCategorie) => {
    setIsLoading(true);
    try {
      if (mode === "create") {
        await categorieService.create(token , data);
        alertSuccess("Catégorie créée avec succès");
      } else if (mode === "edit" && categorie) {
        const response = await categorieService.update(token , categorie.id, data);

        console.log(response)
        alertSuccess("Catégorie modifiée avec succès");
      }
      onSuccess();
      onClose();
    } catch (error: any) {
      console.error(error.response)
      alertError(error.message || "Erreur lors de l'enregistrement");
    } finally {
      setIsLoading(false);
    }
  };

  const title = mode === "create" ? "Nouvelle catégorie" : "Modifier la catégorie";
  const submitLabel = mode === "create" ? "Créer" : "Mettre à jour";

  return (
    <BaseModal isOpen={isOpen} onClose={onClose} title={title} icon={<Tag className="w-5 h-5 text-white" />}>
      <CategorieForm
        initialData={initialData}
        onSubmit={handleSubmit}
        onCancel={onClose}
        isLoading={isLoading}
        submitLabel={submitLabel}
        title={title}
      />
    </BaseModal>
  );
}
